import {Auth, API} from "aws-amplify";

let apiName = process.env.REACT_APP_APINAME;
let path = "";
let requestBody = "";


class AdminService {

    async allUsers(params = {}, callback) {

        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        path = process.env.REACT_APP_URL_GETALLUSERS;
        requestBody = {
            body: {...params},
            headers: {
                Authorization: token,
                "Content-Type": "application/json"
            },
        };

        API.post(apiName, path, requestBody).then(data => {
            return callback(null, data);
        }).catch(error => {
            return callback(error, null);
        });
    }

    async getUserById(userId, callback) {

        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        path = process.env.REACT_APP_URL_GETUSERSBUID;
        requestBody = {
            body: {"userId": userId},
            headers: {
                Authorization: token,
                "Content-Type": "application/json"
            }
        };

        API.post(apiName, path, requestBody).then(data => {
            return callback(null, data);
        }).catch(error => {
            return callback(error, null);
        });
    }

    async userStateChange(userId, option, callback) {

        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        path = process.env.REACT_APP_URL_USERSTATECHANGE;
        requestBody = {
            body: {"userId": userId, "option": option},
            headers: {
                Authorization: token,
                "Content-Type": "application/json"
            }
        };

        API.post(apiName, path, requestBody).then(data => {
            return callback(null, data);
        }).catch(error => {
            return callback(error, null);
        });
    }

    async userAttributeChange(userId, attList, callback) {

        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        path = process.env.REACT_APP_URL_USERATTRCHANGE;
        requestBody = {
            body: {"userId": userId, "attList": attList},
            headers: {
                Authorization: token,
                "Content-Type": "application/json"
            }
        };

        API.post(apiName, path, requestBody).then(data => {
            return callback(null, data);
        }).catch(error => {
            return callback(error, null);
        });
    }

    async getDashboardWidgetData(callback){

        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        path = process.env.REACT_APP_URL_DASHBOARD;
        requestBody = {
            headers: {
                Authorization: token,
                "Content-Type": "application/json"
            }
        };

        API.post(apiName, path, requestBody).then(data => {
            return callback(null, data);
        }).catch(error => {
            return callback(error, null);
        });
    }
}

export default AdminService;